import { Enter, ShiftEnter, SelectAll, Clipboard, Typing, Undo, GeneralHtmlSupport, PasteFromOffice, Plugin } from "@pebblepad/ckeditor";
import { PpMarkerRangePlugin } from "../../editor-plugins/pp-marker-range-plugin/PpMarkerRangePlugin";

export const baseCkEditorPlugins: ReadonlyArray<typeof Plugin> = [
    Enter,
    ShiftEnter,
    SelectAll,
    Clipboard,
    Typing,
    Undo,
    GeneralHtmlSupport,
    PasteFromOffice,
    PpMarkerRangePlugin
];
